module.exports = __webpack_public_path__ + "284c862de3c97a695bfcec794a4e674d.png";